<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div id="map" class="map"></div>
    <c-name
      v-if="JSON.stringify(param) !== '{}'"
      :param="param"
      class="detail"
    ></c-name>
  </div>
</template>

<script>
import L from "leaflet";
// import "leaflet/dist/leaflet.css";
import cName from "../util/name";
import { findOrgCompanyByIsSubjectGetOrgCompany } from "@/api/base";
import { mapGetters } from "vuex";
import changeMap from "../util/changeMap";
export default {
  components: {
    cName
  },
  computed: {
    ...mapGetters(["layerComponent"])
  },
  watch: {
    layerComponent(val) {
      this.pointChoose(val);
    }
  },
  data() {
    return {
      type: "",
      map: null,
      daiArr: [],
      param: {},
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      ydArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      mianArr: []
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var url = require("images/map/dt1.png");
      var map = L.map("map", {
        minZoom: 17,
        maxZoom: 20,
        center: [-0.00200653076171875, 0.0021896362304687],
        zoom: 17,
        crs: L.CRS.Simple,
        attributionControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      var bounds = new L.LatLngBounds(southWest, northEast);
      L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      this.areaLoad();
      this.nowZoom = this.map.getZoom();
      map.on("click", e => {
        console.log(e.latlng);
      });
      map.on("move", () => {
        this.param = {};
      });
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i]
        }).addTo(this.map);
      }
      this.lndnLoad();
      //   this.areaLoad1();
    },
    //联农带农数据加载
    lndnLoad() {
      findOrgCompanyByIsSubjectGetOrgCompany().then(res => {
        res.data.map(it => {
          if (it.latitude) {
            let aPoint = new changeMap(it.latitude, it.longitude);
            it.lat = aPoint.lat;
            it.lng = aPoint.lng;
            let pointIcon = L.icon({
              iconUrl: require("images/map/icon_lndn.png"),
              iconSize: "31",
              iconAnchor: [10, 40],
              popupAnchor: [0, 0]
            });
            let ssztLayer = L.marker([it.lat, it.lng], {
              icon: pointIcon,
              attributes: it
            }).addTo(this.map);
            ssztLayer.on("click", e => {
              this.$store.dispatch(
                "drawer/setGraphic",
                e.sourceTarget.options.attributes
              );
              this.$store.dispatch("drawer/setRightComponent", "lndnDrawer");
            });
            ssztLayer.on("mouseover", it => {
              this.param = {
                x: it.containerPoint.x,
                y: it.containerPoint.y,
                name: it.sourceTarget.options.attributes.name
              };
              this.ncCode = it.target.options.attributes.code;
            });
            ssztLayer.on("mouseout", () => {
              this.param = {};
            });
          }
        });
      });
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9
    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none
    >>>.leaflet-bottom
        display none
    .ncDetail
        position absolute
    >>>
        .ztgh-div-icon
            color #fff
            z-index 970 !important
        .indicator-box
            position relative
        .ztgh-div-image
            position relative
            width 0.1rem
            height 0.1rem
        .ico_sf
            width 0.6rem
            height 0.6rem
        .ztgh-div-text
            position absolute
            width 1.3rem
            height 30px
            display flex
            justify-content center
            align-items center
        .mys-div-right
            top -18px
            left -0.2rem
            text-align center
        .mys-div-left
            text-align center
            top -18px
            right 0.25rem
        .ztgh-div-name
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, 0.8)
            padding 2px 8px
        .ztgh-div-name:hover
            z-index 999
            font-size 0.09rem
        .ztgh-div-names
            font-size 0.08rem
            color #FFF
            position absolute
            width 1.2rem
            text-shadow -1px 0 #FF770C, 0 1px #FF770C, 1px 0 #FF770C, 0 -1px #FF770C
        .ztgh-div-names:hover
            z-index 999
            font-size 0.09rem
        .sLine
            transform translate(-50%, -50%)
        .mys-div-s
            top -25px
            left -0.35rem
            text-align center
        img
            display inline-block
        .ztgh-div-left
            position absolute
            top -15px
            right 0
            img
                width 100px
            span
                text-align right
                position absolute
                right 100px
                top -11px
        .ztgh-div-right
            transform rotateY(180deg)
            position absolute
            top 6px
            left 24px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
        .zxd-div-right
            transform rotateY(180deg)
            position absolute
            top -9px
            left 18px
            img
                width 100px
            span
                transform rotateY(-180deg)
                position absolute
                right 100px
                top -11px
@media (max-width 1280px)
  .mapDiv
    transform scale(0.75)
</style>
